import { KeyValue } from 'interfaces/keyValue';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { MessagesScreenAction } from 'redux/reducers/messagesReducer';

export const setFormValue = (keyValue: KeyValue): Action<MessagesScreenAction, KeyValue> =>
  createAction(MessagesScreenAction.setFormValue, keyValue);
